import { render, staticRenderFns } from "./regist-result.vue?vue&type=template&id=f56dde50&"
import script from "./regist-result.vue?vue&type=script&lang=js&"
export * from "./regist-result.vue?vue&type=script&lang=js&"
import style0 from "./regist-result.vue?vue&type=style&index=0&id=f56dde50&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports